import React, { useRef, useState } from 'react';
import { ArrowRight, Footprints } from 'lucide-react';
import { Badge, Button } from './ui';
const MOBILE_BREAKPOINT = 768;
const SCROLL_SETTLE_DELAY = 700;
const CORRECTION_THRESHOLD = 20;
export function Hero() {
  const isNavigatingRef = useRef(false);
  const [isNavigating, setIsNavigating] = useState(false);
  const scrollToPayment = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (isNavigatingRef.current) return;
    const destination = document.getElementById('bloque-pago');
    if (!destination) return;
    isNavigatingRef.current = true;
    setIsNavigating(true);
    try {
      await document.fonts.ready;
      await nextFrame();
      await nextFrame();
      scrollToDestination(destination);
      window.setTimeout(() => {
        const refreshedDestination = document.getElementById('bloque-pago');
        if (refreshedDestination) {
          const offset = getScrollOffset();
          const targetPosition = getDestinationPosition(refreshedDestination, offset);
          if (Math.abs(window.scrollY - targetPosition) > CORRECTION_THRESHOLD) {
            window.scrollTo({
              top: targetPosition,
              behavior: getScrollBehavior()
            });
          }
        }
        isNavigatingRef.current = false;
        setIsNavigating(false);
      }, SCROLL_SETTLE_DELAY);
    } catch {
      isNavigatingRef.current = false;
      setIsNavigating(false);
    }
  };
  return <section className="relative pt-4 pb-16 md:pt-6 md:pb-24 px-4 overflow-hidden pl-[16px] pr-[16px]" data-id="element-13" data-mp="358hlsq2dxr0z">
      <div className="hero-background-glow absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-14" data-mp="2qk3lomwcsgo4" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-15" data-mp="2hj5czrayzkz7">
        <div className="inline-flex items-center gap-2 mb-4" data-id="element-16" data-mp="2hjymv1586qlk">
          <Footprints className="w-6 h-6 text-brand-400" aria-hidden="true" data-id="element-17" data-mp="2ljpawx3dasme" />
          <span className="text-brand-400 font-bold tracking-widest uppercase text-sm md:text-base" data-id="element-18" data-mp="s2jmpvqkdyiz">
            PUNTO DIGITAL™
          </span>
        </div>

        <h1 className="md:text-[52px] font-black text-white mb-4 tracking-tight text-[23px]" data-id="element-19" data-mp="n98crlqgh1mu">
          TODO LO QUE NECESITÁS PARA CORRER
          <br data-id="element-20" data-mp="ddnhe6fw6zm2" />
          <span className="text-brand-400 text-glow" data-id="element-21" data-mp="ddwyf4iylwfm">TUS PRIMEROS 5 KM</span>
        </h1>

        <div className="relative mt-4 mb-6 flex justify-center" data-id="element-22" data-mp="1b1fd0vzaxsrj">
          <div className="hero-product-glow absolute inset-0 bg-brand-500/20 blur-[80px] rounded-full pointer-events-none" data-id="element-23" data-mp="1ayjgnc33rc57" />
          <img src="https://cdn.magicpatterns.com/uploads/tsZ9Zvn6Mxrk88kgjojFJY/Ajuste_a_420x420.png" alt="Running Desde Cero: megapack de seis tomos y cinco bonos para completar tus primeros 5 kilómetros" className="hero-mockup relative z-10 w-full max-w-lg h-auto drop-shadow-2xl pl-[45px] pr-[45px]" width={420} height={420} loading="eager" fetchPriority="high" decoding="async" data-id="element-24" data-mp="1126pakv15adm" />
        </div>

        <p className="text-slate-400 max-w-2xl mx-auto text-[14px] mt-[3px] mb-[3px]" data-id="element-25" data-mp="21aejjiz1mpbo">
          Pasá de no poder correr dos cuadras a completar tus primeros 5 kilómetros con un sistema paso a paso diseñado para principiantes, sin lesiones, sin gastar de más y sin abandonar a mitad de camino.
        </p>

        <div className="flex flex-nowrap justify-center gap-2 mb-8 overflow-x-auto" data-id="element-26" data-mp="2g0lpx0bs0hw0">
          <Badge className="whitespace-nowrap" data-id="element-27" data-mp="2kyduattlxwh3">✅ 100% Digital</Badge>
          <Badge className="whitespace-nowrap" data-id="element-28" data-mp="2l0q9iz7zdsqg">⚡ Acceso inmediato</Badge>
          <Badge className="whitespace-nowrap" data-id="element-29" data-mp="2p10ec8k1ed3q">🏃 6 Tomos + 5 Bonos</Badge>
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-30" data-mp="2tyafglgsgd7e">
          <Button type="button" size="md" className="w-full md:w-auto group" onClick={scrollToPayment} disabled={isNavigating} data-id="element-31" data-mp="umpqa2b9nmz0">
            <span className="group-hover:scale-110 transition-transform" data-id="element-32" data-mp="4b49k00jcgmm">
              🏃 SÍ, QUIERO CORRER MIS PRIMEROS 5 KM
            </span>
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-33" data-mp="3vh5km8ki3a89" />
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-slate-400" data-id="element-34" data-mp="e7h9vgql5sqc">
            <span className="flex items-center" data-id="element-35" data-mp="98e39ruyjeg9">🛡️ Garantía 7 días</span>
            <span className="flex items-center" data-id="element-36" data-mp="3hqse8an9c3l1">🔒 Pago seguro</span>
            <span className="flex items-center" data-id="element-37" data-mp="3cryz6dsbo4ir">⚡ Descarga inmediata</span>
          </div>
        </div>
      </div>
    </section>;
}
function nextFrame() {
  return new Promise<void>(resolve => {
    requestAnimationFrame(() => resolve());
  });
}
function getScrollOffset() {
  return window.innerWidth <= MOBILE_BREAKPOINT ? 8 : 12;
}
function getDestinationPosition(destination: HTMLElement, offset: number) {
  return destination.getBoundingClientRect().top + window.scrollY - offset;
}
function scrollToDestination(destination: HTMLElement) {
  const offset = getScrollOffset();
  const position = getDestinationPosition(destination, offset);
  window.scrollTo({
    top: position,
    behavior: getScrollBehavior()
  });
}
function getScrollBehavior(): ScrollBehavior {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}